import { useState } from "react";
import AppLogo from "../assets/LogoLoader.js"; // React SVG component

const LogoLoader = ({ isLoading }) => {
  const [shouldRender, setShouldRender] = useState(true);

  const handleTransitionEnd = () => {
    if (!isLoading) {
      setShouldRender(false);
    }
  };

  if (!shouldRender) return null;

  return (
    <div
      className={`fixed logo-wrapper inset-0 flex justify-center items-center bg-white z-[100] transition-opacity duration-700 ${
        isLoading ? "opacity-100 visible" : "opacity-0 invisible"
      }`}
      onTransitionEnd={handleTransitionEnd}
    >
      <AppLogo className="w-full logoGroup z-[101]" />
    </div>
  );
};

export default LogoLoader;
